import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { fairValueInstrumentInputs } from './constants'
import { type IFairValueInstrument, emptyFairValueInstrument } from './types'

export const EditFairValueInstrumentDialog = ({
  item,
  onClose,
  onSave,
}: {
  item: Partial<IFairValueInstrument> | null
  onClose: () => void
  onSave: (data: Partial<IFairValueInstrument>) => Promise<void>
}) => {
  const [form, setForm] = useState<Partial<IFairValueInstrument>>(emptyFairValueInstrument())
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!item) return
    setForm({ ...item })
  }, [item])

  const inputs = useMemo(() => fairValueInstrumentInputs(form), [form])

  if (!item) return null

  const onChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const onSubmit = async () => {
    setSaving(true)
    try {
      await onSave({
        section: form.section,
        instrument: form.instrument,
        reference: form.reference,
        notional: form.notional != null && form.notional !== ('' as any) ? Number(form.notional) : null,
        fvGlAccountNo: form.fvGlAccountNo,
        fairValue: Number(form.fairValue || 0),
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen
      title={item.id ? 'Edit Instrument' : 'Add Instrument'}
      loading={saving}
      disabled={!form.instrument?.trim() || !form.fvGlAccountNo?.trim()}
      onOk={onSubmit}
      onClose={onClose}
      titleOkay="Save"
      titleCancel=""
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} />
        ))}
      </div>
    </Modal>
  )
}
